import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text, Switch, AuctionCountdown } from "../../components";
import AddPageProviderRow1 from "../../components/AddPageProviderRow1";
import AddPageProviderRow2 from "../../components/AddPageProviderRow2";
import TestFile3AfterColumn from "../../components/TestFile3AfterColumn";
import React, { Suspense, useState, useEffect } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import LeftMenuOffersProvider from "components/LeftMenuOffersProvider";
import "styles/style.css";
import { API_DOMAIN_IMG, API_DOMAIN } from "config";
import axios from "axios";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/ImageCarousel";
import AddNewOfferTemplate from "components/AddNewOfferTemplate";
import SendNewOfferPopup from "components/SendNewOfferPopup";
import SendNewOfferMobilePopup from "components/SendNewOfferMobilePopup";
import LeftMenuNotificationsDealer from "components/LeftMenuNotificationsDealer";
import EditCar from "components/EditCar";
import LeftSendOffer from "components/LeftSendOffer";
import { JoyrideTour, getVehicleTourSteps, isOnboardingStateSyncReady, isTourDone, useTour } from "../../onboarding";

const hasDocUrl = (value) => String(value ?? "").trim() !== "";

const resolveDocUrl = (value) => {
  const url = String(value ?? "").trim();
  if (!url) return "";
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:") || url.startsWith("blob:")) {
    return url;
  }

  const base = String(API_DOMAIN || "").replace(/\/+$/, "");
  const path = url.replace(/^\/+/, "");
  return base ? `${base}/${path}` : `/${path}`;
};

const buildDocumentViewUrl = (carId, type, fallbackUrl) => {
  if (!carId || !type) return resolveDocUrl(fallbackUrl);

  const base = String(API_DOMAIN || "").replace(/\/+$/, "");
  const path = `/car/viewDocument/${encodeURIComponent(carId)}?type=${encodeURIComponent(type)}`;
  return base ? `${base}${path}` : path;
};

function DocumentIcon({ accent = "#CE0000" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
      <path
        d="M7 3h7l4 4v14H7V3Z"
        fill="#fff"
        stroke={accent}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M14 3v5h5" stroke={accent} strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9.5 12h5M9.5 16h7" stroke="#111827" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

const transactionDetailsList = [
  { blocktitle: "פרטי הרכב" },
  { blocktitle: "מפרט טכני" },
  { blocktitle: "מנוע וביצועים" },
  { blocktitle: "אבזור ונוחות" },
  // { blocktitle: "מידע על העיסקה" },
];

export default function CarFullProfile({ currentUser }) {
  const { id } = useParams();
  const {
    endTour,
    isManualTour,
    runVehicleTour,
    setStepIndex,
    startVehicleTour,
    stepIndex,
  } = useTour();

  const [car, setCar] = useState([]);
  const [loadingCar, setLoadingCar] = useState(true);
  const [auctionStatus, setAuctionStatus] = useState(null);

  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [isDealer, setIsDealer] = useState(true);

  const [offer, setOffer] = useState(null);
  const [hasRejectedOrApproved, setHasRejectedOrApproved] = useState(false);
  const [loadingOffer, setLoadingOffer] = useState(true);

  const [accessoriesSelected, setAccessoriesSelected] = useState(car?.accessories || []);
  const [isEditCarPopupOpen, setIsEditCarPopupOpen] = useState(false);

  const [isAddNewOfferPopupOpen, setIsAddNewOfferPopupOpen] = useState(false);
  const [isAddNewOfferMobilePopupOpen, setIsAddNewOfferMobilePopupOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isMobileTour, setIsMobileTour] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(max-width: 768px)").matches;
  });
  const hasStartedVehicleTourRef = React.useRef(false);
  const auctionEndedSyncRef = React.useRef("");
const navigate = useNavigate();
const location = useLocation();
  const currentUserType = Number(currentUser?.user_type);

const handleBack = () => {
  const backUrl = location.state?.backUrl;

  if (backUrl) {
    navigate(backUrl, { replace: true });
  } else {
    navigate(-1); // אם אין backUrl, חוזר רגיל
  }
};

  const [checkboxes, setCheckboxes] = useState({
    למכירה: true,
    לפירוק: false,
    למכרז: false,
  });

  const effectiveTourUserId = React.useMemo(() => {
    if (currentUser?.id) return currentUser.id;

    try {
      const raw = localStorage.getItem("currentUser");
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed?.id || null;
    } catch {
      return null;
    }
  }, [currentUser?.id]);

  const toggleTab = (tabIndex) => {
    setActiveTab(activeTab === tabIndex ? null : tabIndex);
  };

  const updateIsAddNewOfferPopupOpen = (state) => {
    setIsAddNewOfferPopupOpen(state);
  };

  const updateIsAddNewOfferMobilePopupOpen = (state) => {
    setIsAddNewOfferMobilePopupOpen(state);
  };

  const isMobile = () => (typeof window !== "undefined" ? window.innerWidth < 768 : false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mq = window.matchMedia("(max-width: 768px)");
    const updateIsMobileTour = () => setIsMobileTour(mq.matches);
    updateIsMobileTour();

    if (mq.addEventListener) {
      mq.addEventListener("change", updateIsMobileTour);
      return () => mq.removeEventListener("change", updateIsMobileTour);
    }

    mq.addListener(updateIsMobileTour);
    return () => mq.removeListener(updateIsMobileTour);
  }, []);

  const openOfferPopup = () => {
    if (isMobile()) {
      updateIsAddNewOfferMobilePopupOpen(true);
    } else {
      updateIsAddNewOfferPopupOpen(true);
    }
  };

useEffect(() => {
  // תמיד לראש העמוד כשנכנסים לפרופיל רכב / כש-id משתנה
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}, [id]);

  const fetchOffer = React.useCallback(async ({ silent = false } = {}) => {
      if (!currentUser?.id || !id) return;
      if (!silent) setLoadingOffer(true);

      try {
        const { data } = await axios.get(`${API_DOMAIN}/offer/getUserOffer`, {
          params: { car_id: id, user_id: currentUser.id },
        });

        const isRejectedOrApproved = data?.status === "2" || data?.status === "3";

        setOffer(data ?? null);
        setHasRejectedOrApproved(isRejectedOrApproved);

        // אם יש הצעה → לכבות "שיריון" (כמו שהיה אצלך)
        setIsSwitchOn(!data);
      } catch (e) {
        console.error("שגיאה בשליפת הצעה קיימת:", e);
      } finally {
        if (!silent) setLoadingOffer(false);
      }
  }, [currentUser?.id, id]);

  useEffect(() => {
    fetchOffer();
  }, [fetchOffer]);

  const fetchCar = React.useCallback(async ({ silent = false } = {}) => {
    if (!id || !currentUser?.id) return;
      try {
        if (!silent) setLoadingCar(true);

        const { data } = await axios.get(`${API_DOMAIN}/car/getCarById/${id}`, {
          params: { user_id: currentUser.id },
        });

        const carData = {
          ...data,
          accessories:
            typeof data.accessories === "string"
              ? JSON.parse(data.accessories)
              : data.accessories || [],
        };

        setCar(carData);
        setAccessoriesSelected(carData.accessories);
      } catch (err) {
        console.error("שגיאה בשליפת רכב:", err);
      } finally {
        if (!silent) setLoadingCar(false);
      }
  }, [currentUser?.id, id]);

  useEffect(() => {
    fetchCar();
  }, [fetchCar]);

  const providerLabel = (() => {
    if (currentUserType === 3) return "סוחר";
    if (currentUser?.provider_type === "private") return "מוכר פרטי";
    return "ספק";
  })();

  const buttonText = !offer
    ? "שלח הצעת מחיר"
    : offer.status === 3 || offer.status === 2
      ? "צפה בהצעת מחיר"
      : offer.status === 1
        ? "עדכן הצעת מחיר"
        : "שלח הצעת מחיר";

  const isAuctionCar =
    auctionStatus?.is_auction === true ||
    Number(car?.is_auction ?? car?.isAuction ?? 0) === 1 ||
    car?.is_auction === true ||
    car?.isAuction === true ||
    String(car?.is_auction ?? car?.isAuction ?? "").toLowerCase() === "true";
  const auctionDisplayStatus = React.useMemo(() => {
    if (auctionStatus?.is_auction) return auctionStatus;
    if (!isAuctionCar) return null;

    const rawStatus = String(car?.auction_status ?? car?.status_auction ?? "").toLowerCase();
    const startValue = car?.auction_start_datetime_iso ?? car?.auction_start_at_iso ?? car?.auction_start_datetime ?? car?.auction_start_at;
    const endValue = car?.auction_active_until_iso ?? car?.auction_end_time_iso ?? car?.auction_active_until ?? car?.auction_end_time ?? car?.auction_end_at;
    const startMs = startValue ? new Date(String(startValue).replace(" ", "T")).getTime() : null;
    const endMs = endValue ? new Date(String(endValue).replace(" ", "T")).getTime() : null;
    const nowMs = Date.now();
    const hasStarted = Number.isFinite(startMs) && nowMs >= startMs;
    const computedEndMs = Number.isFinite(endMs)
      ? endMs
      : Number.isFinite(startMs)
        ? startMs + (5 * 60 * 1000)
        : null;
    const hasEnded =
      Boolean(car?.auction_finalized_at) ||
      ["ended", "finalized"].includes(rawStatus) ||
      (hasStarted && Number.isFinite(computedEndMs) && nowMs >= computedEndMs);
    const status = !hasStarted ? "upcoming" : hasEnded ? "ended" : "active";

    return {
      ...car,
      is_auction: true,
      status,
      auction_status: status,
      has_started: hasStarted,
      has_ended: hasEnded,
      can_bid: status === "active",
      auction_start_datetime: car?.auction_start_datetime,
      auction_start_at: car?.auction_start_datetime,
      auction_active_until: car?.auction_active_until,
      auction_end_time: car?.auction_active_until,
    };
  }, [auctionStatus, car, isAuctionCar]);
  const auctionLifecycleStatus = String(auctionDisplayStatus?.status ?? car?.auction_status ?? car?.status_auction ?? "").toLowerCase();
  const auctionHasEnded =
    auctionDisplayStatus?.has_ended === true ||
    car?.has_ended === true ||
    Number(car?.auction_has_ended ?? car?.auctionHasEnded ?? 0) === 1 ||
    Boolean(car?.auction_finalized_at) ||
    ["ended", "finalized"].includes(auctionLifecycleStatus);
  const isOpenAuctionForOffer = isAuctionCar && !auctionHasEnded;
  const isArchiveStatus =
    (Number(car?.is_archive ?? 0) === 1 || Number(car?.not_interested ?? 0) === 1) &&
    !offer &&
    !isOpenAuctionForOffer;

  const hideTopMenu =
    Number(offer?.status ?? 0) === 2 ||
    Number(offer?.status ?? 0) === 3 ||
    isArchiveStatus ||
    Number(currentUser?.user_type ?? 0) === 2;

  const canShowProviderAuctionPanel = (currentUserType === 2 || currentUserType === 1) && isAuctionCar;
  const canShowVehicleOfferPanel =
    canShowProviderAuctionPanel ||
    (currentUserType === 3 &&
      !loadingOffer &&
      !isArchiveStatus &&
      offer?.offer_status !== 5);
  const canShowDesktopPriceOfferButton = !(currentUserType === 3 && isAuctionCar);
  const canShowMobilePriceOfferButton = currentUserType === 3;
  const onboardingSyncReady = isOnboardingStateSyncReady(effectiveTourUserId);
  const isManualVehicleTour = isManualTour("vehicle");
  const vehicleTourSteps = React.useMemo(() => getVehicleTourSteps(isMobileTour), [isMobileTour]);

  // פונקציה לבדיקת targets מוכנים
  const areVehicleTargetsReady = () => {
    return vehicleTourSteps.every((step) => {
      const element = document.querySelector(step.target);
      if (!element) return false;
      
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity) !== 0 &&
        rect.width > 0 &&
        rect.height > 0
      );
    });
  };

  const canRunVehicleTour =
    runVehicleTour &&
    onboardingSyncReady &&
    !loadingCar &&
    !loadingOffer &&
    canShowVehicleOfferPanel &&
    (isManualVehicleTour || !isTourDone("vehicle", effectiveTourUserId)) &&
    areVehicleTargetsReady();

  const DEFAULT_IMG = "/images/img_car11_qgcqjcnfp_428x738.png";

  const fetchAuctionStatus = React.useCallback(async () => {
    if (!id || !currentUser?.id) return;

    try {
      const { data } = await axios.get(`${API_DOMAIN}/car/getAuctionStatus/${id}`, {
        params: { user_id: currentUser.id },
      });
      setAuctionStatus(data);

      const status = String(data?.status ?? data?.auction_status ?? "").toLowerCase();
      const hasEnded = data?.has_ended === true || ["ended", "finalized"].includes(status);

      if (hasEnded) {
        const syncKey = [
          data?.auction_finalized_at ?? "",
          data?.auction_winning_offer_id ?? "",
          data?.auction_winner_user_id ?? "",
          status,
        ].join("|");

        if (auctionEndedSyncRef.current !== syncKey) {
          auctionEndedSyncRef.current = syncKey;
          await Promise.all([
            fetchOffer({ silent: true }),
            fetchCar({ silent: true }),
          ]);
        }
      } else {
        auctionEndedSyncRef.current = "";
      }
    } catch (err) {
      console.error("שגיאה בטעינת מצב מכרז:", err);
    }
  }, [currentUser?.id, fetchCar, fetchOffer, id]);

  useEffect(() => {
    if (!id || !currentUser?.id || !isAuctionCar) {
      setAuctionStatus(null);
      return undefined;
    }

    fetchAuctionStatus();
    const intervalId = setInterval(fetchAuctionStatus, 5000);
    return () => clearInterval(intervalId);
  }, [currentUser?.id, fetchAuctionStatus, id, isAuctionCar]);

  const displayImages = React.useMemo(() => {
    if (loadingCar) return [];
    const has = Array.isArray(car?.images) && car.images.length > 0;
    return has ? car.images : [{ image_url: DEFAULT_IMG, __isDefault: true }];
  }, [car?.images, loadingCar]);

  const getSafeImage = (imagesArr) => {
    if (!Array.isArray(imagesArr) || imagesArr.length === 0) return null;
    return imagesArr[1] || imagesArr[0];
  };

  const mainImage = getSafeImage(displayImages);
  const docTabIndex = transactionDetailsList.length;
  const carDocuments = [
    { key: "license", title: "מידע משרד התחבורה", url: car?.license_doc_url, accent: "#CE0000" },
    { key: "priceList", title: "מחיר לוי יצחק", url: car?.price_list_doc_url, accent: "#111827" },
    { key: "partsList", title: "מסמך חלקי חילוף", url: car?.parts_list_doc_url, accent: "#64748B" },
  ]
    .filter((doc) => hasDocUrl(doc.url))
    .map((doc) => ({ ...doc, href: buildDocumentViewUrl(car?.id ?? id, doc.key, doc.url) }));

  const imageRequestVersion = React.useMemo(
    () => Date.now(),
    [car?.updated_date, car?.images]
  );

  const buildImgSrc = (imgObj) => {
    if (!imgObj?.image_url) return DEFAULT_IMG;
    if (imgObj.__isDefault) return imgObj.image_url;
    const src = `${API_DOMAIN}/${imgObj.image_url}`;
    return `${src}${src.includes("?") ? "&" : "?"}v=${imageRequestVersion}`;
  };

  useEffect(() => {
    if (hasStartedVehicleTourRef.current) return;
    if (currentUserType !== 3) return;
    if (!onboardingSyncReady) return;
    if (loadingCar || loadingOffer) return;
    if (!canShowVehicleOfferPanel) return;
    if (isTourDone("vehicle", effectiveTourUserId)) return;

    // המתן קצר לפני בדיקת targets
    const timer = setTimeout(() => {
      if (areVehicleTargetsReady()) {
        hasStartedVehicleTourRef.current = true;
        startVehicleTour();
      } else {
        console.warn("[Vehicle Tour] targets not ready", {
          isMobileTour,
          missingTargets: vehicleTourSteps
            .filter((step) => !document.querySelector(step.target))
            .map((step) => step.target),
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [
    canShowVehicleOfferPanel,
    currentUserType,
    effectiveTourUserId,
    isMobileTour,
    loadingCar,
    loadingOffer,
    onboardingSyncReady,
    startVehicleTour,
    vehicleTourSteps,
  ]);

  return (
    <>
      <JoyrideTour
        run={canRunVehicleTour}
        steps={vehicleTourSteps}
        stepIndex={stepIndex}
        tourName="vehicle"
        onEnd={(status) => endTour("vehicle", effectiveTourUserId, status)}
        onStepChange={setStepIndex}
      />
      {/* ✅ עטיפת עמוד עם קלאס ייעודי למובייל בלבד */}
      <div className="car-full-profile-page">
        {isAuctionCar && auctionDisplayStatus && (
          <div className="car-auction-top-timer" dir="rtl">
            <AuctionCountdown
              auctionStatus={auctionDisplayStatus}
              onUpdate={fetchAuctionStatus}
              variant="topFloating"
            />
          </div>
        )}
        <div
          className="car-full-profile car-full-profile-shell flex bg-blue_gray-50 p-8 sm:p-4"
          style={{ width: "73.5%", marginLeft: "21%", paddingTop: "1rem" }}
        >
          <div className="container-9xl flex items-start gap-10 md:flex-col">
            <div className="relative pt-0 flex flex-1 flex-col items-start gap-[30px] self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4 car-full-profile-card">
              {/* פס עליון */}
                <div style={{width: '15%'}} className=" crumbs ml-3 w-[9%] absolute top-0 left-0 h-8  flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                <div className="flex w-full justify-center gap-1">
                  <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                    <span className="text-gray-900_04">&nbsp;</span>
                    <span className="font-heebo font-medium text-gray-600">מודעת רכב</span> 
                  </Heading>
                  <Img src="/images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                </div>
                <div className="flex w-full items-center justify-center">
                  <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                   {providerLabel}
                  </Heading>
                  <Img src="/images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                </div>
              </div>
              <div className="flex flex-col gap-5 self-stretch px-11 md:px-5 sm:px-4 car-full-profile-body">
                <div className="mx-3.5 flex flex-col gap-[26px] md:mx-0 mt-4 car-full-profile-header">
                  {/* Breadcrumb */}
                  <div className="flex items-center justify-center car-full-profile-breadcrumb">
                    <div className="flex flex-1 justify-end">
                      <Text size="textlg" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px]">
                        {car?.model} {" "}{car?.manufacturer}
                      </Text>
                    </div>

                    <div className="flex w-[6%] items-center justify-center gap-1">
                      <Text as="p" className="!font-dmsans text-[14px] font-normal">&nbsp;/</Text>
                      <div className="flex flex-1 justify-center">
                        <Text size="h4_assistant16px_r" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px] w-18px">
                          {providerLabel}
                        </Text>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-1 py-0.5">
                      <Text as="p" className="!font-dmsans text-[14px] font-normal">&nbsp;/</Text>
                      <Text size="textlg" as="p" className="self-end text-[16px] font-normal !text-black-900_7f lg:text-[13px]">
                        ראשי
                      </Text>
                    </div>
                  </div>

                  {/* כפתור עריכת רכב (ספק) */}
                  {currentUser?.user_type === 2 && (
                    <div className="mb-1.5 flex flex-1 items-center justify-center md:flex-col md:self-stretch car-full-profile-editrow">
                      <Button
                        size="lg"
                        shape="round"
                        leftIcon={
                          <div className="flex h-[10px] w-[6px] items-center justify-center">
                            <span className="text-lg leading-none">‹</span>
                          </div>
                        }
                        className="min-w-[128px] gap-2 rounded-[16px] px-3 font-semibold bg-black text-white"
                        style={{ background: "black", color: "white" }}
                        onClick={() => setIsEditCarPopupOpen(true)}
                      >
                        עריכת רכב
                      </Button>
                      <div className="flex flex-1 items-center justify-center px-2.5 md:self-stretch" />
                    </div>
                  )}

                  {/* שורה עליונה עם כפתור + switch + כותרת */}
                  {!hideTopMenu && (
                    <div className="hide-mobile flex items-center justify-center md:flex-col car-full-profile-actions">
                      <div className="mb-1.5 flex flex-1 items-center justify-center md:flex-col md:self-stretch car-full-profile-actions-left">
                        {canShowDesktopPriceOfferButton && (
                        <Button
                          size="lg"
                          shape="round"
                          leftIcon={
                            <div className="flex h-[10px] w-[6px] items-center justify-center">
                              <span className="text-lg leading-none">‹</span>
                            </div>
                          }
                          className="car-full-profile-offer-button min-w-[128px] gap-2 rounded-[16px] px-3 font-semibold bg-black text-white"
                          style={{ background: "black", color: "white" }}
                          onClick={() => { openOfferPopup(); }}
                        >
                          {buttonText}
                        </Button>
                        )}

                        <div className="flex flex-1 items-center justify-center px-2.5 md:self-stretch car-full-profile-switchwrap">
                        {/*  <Switch
                            checked={isSwitchOn}
                            onCheckedChange={(val) => {
                              setIsSwitchOn(val);
                              if (!val) {
                                updateIsAddNewOfferPopup(true);
                              }
                            }}
                          />*/}
                        {/*  <div className="flex flex-1 self-end px-[26px] sm:px-4 car-full-profile-switchlabel">
                            <Text size="textxl" as="p" className="text-[16px] font-normal !text-black-900_03 lg:text-[13px]">
                              שיריון הרכב
                            </Text>
                          </div>*/}
                        </div>
                      </div>

                      <Heading
                        size="h1_assistant_45px_m"
                        as="h4"
                        className="text-[45px] font-semibold !text-black-900 lg:text-[38px] md:text-[29px] sm:text-[23px] car-full-profile-title"
                      >
                        {car?.model} {" "}{car?.manufacturer}
                      </Heading>
                    </div>
                  )}
                </div>

                {/* וידאו + תמונה + קרוסלה */}
                <div className="vehicle-gallery mx-3.5 flex items-center gap-5 md:mx-0 md:flex-col car-full-profile-media" data-testid="vehicle-gallery">
                  <div className="flex w-[32%] flex-col gap-5 md:w-full car-full-profile-media-left">
                    {car?.video_url ? (
                      <video controls className="h-[204px] w-full rounded-[16px] object-cover bg-black car-full-profile-video">
                        <source src={`${API_DOMAIN}/${car.video_url}`} type="video/mp4" />
                        הדפדפן שלך לא תומך בניגון וידאו.
                      </video>
                    ) : (
                      <div className="h-[204px] w-full rounded-[16px] bg-gray-300 flex items-center justify-center text-gray-500 text-sm car-full-profile-video-placeholder">
                        <img src="/images/viedio-icon.svg" alt="video placeholder" />
                      </div>
                    )}

                    {mainImage ? (
                      <Img
                        src={buildImgSrc(mainImage)}
                        alt="car image"
                        className="h-[204px] rounded-[16px] object-cover w-full car-full-profile-mainimg"
                      />
                    ) : (
                      <div className="h-[204px] w-full rounded-[16px] bg-gray-300 flex items-center justify-center text-gray-500 text-sm car-full-profile-mainimg-placeholder">
                        אין תמונה
                      </div>
                    )}
                  </div>

                  <div className="flex-1 car-full-profile-carousel">
                    <ImageCarousel images={displayImages} />
                  </div>
                </div>

                {/* טאבים */}
                <div className="ml-3.5 md:ml-0 car-full-profile-tabs" style={{ marginBottom: "33vh" }}>
                  <div className="flex flex-col gap-2.5 rounded-md bg-secondary-primary_white" />
                  <div className="vehicle-details-accordion flex flex-col dir-rtl car-full-profile-tabslist" data-testid="vehicle-details-accordion">
                    <Suspense fallback={<div>Loading feed...</div>}>
{transactionDetailsList.map((d, index) => (
  <AddPageProviderRow2
    {...d}
    key={"list" + index}
    toggleTab={toggleTab}
    index={index}
    activeTab={activeTab}
    car={car}
    currentUser={currentUser}   // ✅ הוספה
    accessoriesSelected={accessoriesSelected}
    setAccessoriesSelected={setAccessoriesSelected}
  />
))}

                      <div
                        onClick={() => toggleTab(docTabIndex)}
                        style={{ backgroundColor: activeTab === docTabIndex ? "#f7f7f7" : "" }}
                        className="vehicle-details-accordion cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md"
                        data-testid="vehicle-documents-accordion-item"
                      >
                        <Img
                          src={activeTab === docTabIndex ? `/images/img_checkmark_black.svg` : `/images/img_arrow_left_white.svg`}
                          className="h-[22px] self-start"
                        />
                        <div className="flex flex-1 justify-end">
                          <Heading size="ass_20" as="h5" className="text-[20px] font-semibold">
                            מסמכים
                          </Heading>
                        </div>
                      </div>

                      {activeTab === docTabIndex && (
                        <div className="flex w-full flex-col gap-3 p-2" dir="rtl">
                          {carDocuments.length > 0 ? (
                            carDocuments.map((doc) => (
                              <div
                                key={doc.key}
                                className="flex items-center justify-between gap-4 rounded-md border border-gray-200 bg-white p-4"
                              >
                                <div className="flex min-w-0 items-center gap-3">
                                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-gray-50">
                                    <DocumentIcon accent={doc.accent} />
                                  </div>
                                  <Heading as="h6" className="truncate !font-heebo text-[17px] font-semibold !text-black-900">
                                    {doc.title}
                                  </Heading>
                                </div>
                                <a
                                  href={doc.href}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-black hover:border-[#CE0000]"
                                  aria-label={`צפייה ב${doc.title}`}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                                    <path
                                      d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                    />
                                  </svg>
                                </a>
                              </div>
                            ))
                          ) : (
                            <div className="rounded-md border border-gray-200 bg-white p-5 text-center font-heebo text-[16px] text-gray-600">
                              לא קיימים מסמכים לרכב זה
                            </div>
                          )}
                        </div>
                      )}

                    </Suspense>
                  </div>
                  {canShowVehicleOfferPanel && (
                      <LeftSendOffer
                        car={car}
                        offer={
                          offer
                            ? {
                                ...offer,
                                offer_id: offer.id,
                                offer_status: offer.offer_status || offer.status,
                                offered_price: offer.offered_price,
                                creation_date: offer.creation_date,
                                collection_date: offer.collection_date,
                                last_payment_date: offer.last_payment_date,
                                reservation_hold_id: offer.reservation_hold_id,
                                payment_method_id: offer.payment_method_id,
                              }
                            : null
                        }
                        currentUser={currentUser}
                        viewOnlyAuction={canShowProviderAuctionPanel}
                        onUpdateOffer={(updatedOffer) => {
                          const newOffer = {
                            ...updatedOffer,
                            id: updatedOffer.id ?? updatedOffer.offer_id,
                            offer_id: updatedOffer.offer_id ?? updatedOffer.id,
                            offer_status: updatedOffer.offer_status ?? updatedOffer.status ?? 1,
                            offered_price: updatedOffer.offered_price,
                            creation_date: updatedOffer.creation_date,
                            collection_date: updatedOffer.collection_date,
                            last_payment_date: updatedOffer.last_payment_date,
                            reservation_hold_id: updatedOffer.reservation_hold_id,
                            payment_method_id: updatedOffer.payment_method_id,
                          };
                          setOffer(newOffer);
                        }}
                        onClose={() => {
                          setIsAddNewOfferPopupOpen(false);
                          if (!offer) {
                            setIsSwitchOn(true);
                          }
                        }}
                      />
                    )}

                  {canShowVehicleOfferPanel && canShowMobilePriceOfferButton && (
                      <Button
                        size="lg"
                        shape="round"
                        data-testid="vehicle-mobile-offer-cta"
                        leftIcon={
                          <div className="flex h-5 w-5 items-center justify-center shrink-0">
                            <span className="text-[22px] leading-none font-normal -mt-[1px]">‹</span>
                          </div>
                        }
                        className="hide-desktop fixed bottom-7 right-1/2 translate-x-1/2 z-50 w-[87vw] max-w-[420px] h-[40px] gap-2 rounded-[16px] bg-black text-white flex flex-row items-center justify-center font-semibold text-[16px] cursor-pointer whitespace-nowrap px-3"
                        style={{ background: "black", color: "white", borderRadius: "50px" }}
                        onClick={() => { openOfferPopup(); }}
                      >
                        {buttonText}
                        <img src="/images/offer-white.svg" alt="offer" className="h-4 w-4" />
                      </Button>
                    )}
                </div>
              </div>
            </div>
          </div>

          {isAddNewOfferPopupOpen && (
            <SendNewOfferPopup
              car={car}
              offer={
                offer
                  ? {
                      ...offer,
                      offer_id: offer.id,
                      offer_status: offer.offer_status || offer.status,
                      offered_price: offer.offered_price,
                      creation_date: offer.creation_date,
                      collection_date: offer.collection_date,
                      last_payment_date: offer.last_payment_date,
                      reservation_hold_id: offer.reservation_hold_id,
                      payment_method_id: offer.payment_method_id,
                    }
                  : null
              }
              currentUser={currentUser}
              onUpdateOffer={(updatedOffer) => {
                const newOffer = {
                  ...updatedOffer,
                  id: updatedOffer.id ?? updatedOffer.offer_id,
                  offer_id: updatedOffer.offer_id ?? updatedOffer.id,
                  offer_status: updatedOffer.offer_status ?? updatedOffer.status ?? 1,
                  offered_price: updatedOffer.offered_price,
                  creation_date: updatedOffer.creation_date,
                  collection_date: updatedOffer.collection_date,
                  last_payment_date: updatedOffer.last_payment_date,
                  reservation_hold_id: updatedOffer.reservation_hold_id,
                  payment_method_id: updatedOffer.payment_method_id,
                };

                setOffer(newOffer);
              }}
              onClose={() => {
                setIsAddNewOfferPopupOpen(false);

                if (!offer) {
                  setIsSwitchOn(true);
                }
              }}
            />
          )}

          {isAddNewOfferMobilePopupOpen && (
            <SendNewOfferMobilePopup
              car={car}
              offer={
                offer
                  ? {
                      ...offer,
                      offer_id: offer.id,
                      offer_status: offer.offer_status || offer.status,
                      offered_price: offer.offered_price,
                      creation_date: offer.creation_date,
                      collection_date: offer.collection_date,
                      last_payment_date: offer.last_payment_date,
                      reservation_hold_id: offer.reservation_hold_id,
                      payment_method_id: offer.payment_method_id,
                    }
                  : null
              }
              currentUser={currentUser}
              onUpdateOffer={(updatedOffer) => {
                const newOffer = {
                  ...updatedOffer,
                  id: updatedOffer.id ?? updatedOffer.offer_id,
                  offer_id: updatedOffer.offer_id ?? updatedOffer.id,
                  offer_status: updatedOffer.offer_status ?? updatedOffer.status ?? 1,
                  offered_price: updatedOffer.offered_price,
                  creation_date: updatedOffer.creation_date,
                  collection_date: updatedOffer.collection_date,
                  last_payment_date: updatedOffer.last_payment_date,
                  reservation_hold_id: updatedOffer.reservation_hold_id,
                  payment_method_id: updatedOffer.payment_method_id,
                };

                setOffer(newOffer);
              }}
              onClose={() => {
                setIsAddNewOfferMobilePopupOpen(false);

                if (!offer) {
                  setIsSwitchOn(true);
                }
              }}
            />
          )}
        </div>

        {isEditCarPopupOpen && (
          <EditCar
            car={car}
            currentUser={currentUser}
            onClose={() => setIsEditCarPopupOpen(false)}
            onCarUpdated={() => {
              setIsEditCarPopupOpen(false);
              fetchCar();
            }}
          />
        )}
      </div>
    </>
  );
}
